import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { DeviceNotification } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "DeviceNotification";
export const DeviceNotificationService = {
	endpoint,
	createSingle: async (data: DeviceNotification) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	myReadNotifications: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/MyReadNotifications`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	myUnreadNotifications: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/MyUnreadNotifications`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	updateSingleById: async (id: number, data: DeviceNotification) => await Service.updateSingleById(endpoint, id, data)
}